import { Trans, useLingui } from "@lingui/react/macro";
import { FilledButton, OutlinedButton } from "@medoma/components/Button/Button";
import { Text } from "@medoma/components/Text/Text";
import styles from "./ProspectActions.module.scss";

export const ProspectActions = () => {
  const { t } = useLingui();

  return (
    <section className={styles.prospectActions} aria-label={t`Bedömning`}>
      <Text element="p">
        <Trans>Patienten är under bedömning</Trans>
      </Text>
      <div className={styles.buttons}>
        <FilledButton asLinkTo="admit">
          <Trans>Fullfölj inskrivning</Trans>
        </FilledButton>
        <OutlinedButton asLinkTo="decline">
          <Trans>Avslå</Trans>
        </OutlinedButton>
      </div>
    </section>
  );
};
